export default "__VITE_ASSET__DTTYHn6X__"